import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type CountryCode } from '@generated/search-bff/index';
import { rolledOutCountries } from '@generated/search-bff/controllers/ai/ai';

/**
 * Gets the list of countries that have AI search enabled.
 */
export async function getAISearchEnabledOutCountries(apiConfig: ApiConfig): Promise<ApiResult<CountryCode[]>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'getAISearchEnabledOutCountries');
    const data = await rolledOutCountries(_apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
